import React, { useEffect, useState } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import './report.css';
import {
    Header, 
    Menu
  } from '../../components';



export default function Reports({})
{
    console.log("entrouuou");

    const [user, setUser] = useState({detail: {name : "Validação"}});
    const [reportSummary, setReportSummary] = useState(null);
    const [reportFeedback, setReportFeedback] = useState(null);
    const [reportTrend, setReportTrend] = useState(null);

    useEffect(()=>
    {
        loadUserReport();
    },[]);

    const loadUserReport = async () => 
    {
        var currentDate = new Date();
        var startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).toISOString();
        var endDate = new Date(currentDate.getFullYear(), currentDate.getMonth()+1, 1).toISOString();

        console.log("dsdsds");
        const reports = await Sdk.Api.dynamic.bridge(`/insights/v1.1/user/reports?filter_period_start=${startDate}&filter_period_end=${endDate}&filter_report_type=monthly`);
        console.log("dsdsds111");
        console.log(reports);
        if (!reports || reports.result.length == 0) return;

        var report = reports.result[0];


        var summary = report.content;//additional_information.user.summary;
        var feedback = report.additional_information.user.feedback;
        var trend = report.additional_information.user.trend
        
        if (summary) setReportSummary(summary);
        if (feedback) setReportFeedback(feedback);
        if (trend) setReportTrend(trend);

        console.log(summary)
        console.log(feedback)
        console.log(trend)
    }

    return (<div>
        <Header
            onEditClick={() => {
            window.location.hash = 'perfil';
            }}
            name={user && user.detail && user.detail.name.split(" ")[0]}
            onCoinsClick={() => this.onCoinsClick()}
            avatar={user && user.avatar ? user.avatar : undefined}
        />
        <div className="rdp-react-template-view-home-content">
            {reportSummary &&<div className='report-container'>
                <div className='title'>Um pouco do seu dia a dia:</div>
                <div className='description'>{reportSummary}</div>
            </div>}

            {reportFeedback &&<div className='report-container'>
                <div className='title'></div>
                <div className='description'>{reportFeedback}</div>
            </div>}

            {reportTrend &&<div className='report-container'>
                <div className='title'> </div>
                <div className='description'>{reportTrend}</div>
            </div>}
        </div>
        {/* <Menu active="dashboard"/> */}
    </div>)
}